module.exports = __webpack_public_path__ + "static/media/finger_printing.a48d2cdf.svg";